import axios from "axios";

import { base_URL } from "../config/config";

// Function to fetch vendor login token
export const fetchVendorLogin = async (email) => {
  const { data } = await axios.post(
    `${base_URL}/api/vendor/admin/login-as-vendor`,
    { email },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminAccessToken")}`,
      },
    }
  );
  return data;
};
